module.exports = __webpack_public_path__ + "assets/images/boundaries/keys-four-new-smc/key-2-2015.svg?v=0fef81f8";